export const PNL_TONES = {
  PROFIT: 'profit',
  LOSS: 'loss',
  NEUTRAL: 'neutral',
};

export function getPnlTone(value) {
  if (value === '' || value === null || value === undefined) {
    return PNL_TONES.NEUTRAL;
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue) || numericValue === 0) {
    return PNL_TONES.NEUTRAL;
  }

  return numericValue > 0 ? PNL_TONES.PROFIT : PNL_TONES.LOSS;
}
